import React from 'react'
import reason1 from '../assets/reason1.jpg';
import reason2 from '../assets/reason2.jpg';

function ReasonForUtilisation() {
    return (

        <div className="container-fluid p-0 ">
            {/* Header */}
            <div className="container-fluid text-white py-4 px-5 d-flex justify-content-center" style={{backgroundColor: "rgba(9, 26, 58, 1)" }}>
                <div className="text-end">
                    <h5 className="fw-semibold mb-1">Reason for utilisation of TNWC</h5>
                    <hr className="border-white opacity-100 ms-auto" style={{ width: "220px" }} />
                </div>
            </div>


            {/* Content */}
            <div className="container py-5">
                <div className="row align-items-start">
                    {/* Illustration */}
                    <div className="col-lg-4 mb-4 mb-lg-0 text-center">
                        <img
                            src={reason1}
                            alt="Reason Illustration"
                            className="img-fluid mb-4"
                            data-aos="fade-down"
                        />
                        <img
                            src={reason2}
                            alt="Warehouse Icon"
                            className="img-fluid w-50"
                            data-aos="fade-up"
                        />
                    </div>


                    {/* Text Content */}
                    <div className="col-lg-8">
                        <ul className="fs-6" >
                            <li className="mb-2" data-aos="fade-left" data-aos-delay="100">Facilitates storage space for the notified commodities at an affordable rate.</li>
                            <li className="mb-2" data-aos="fade-left" data-aos-delay="200">Godowns constructed with modern technique suited to large scale storage.</li>
                            <li className="mb-2" data-aos="fade-left" data-aos-delay="300">Easy accessibility to social infrastructure.</li>
                            <li className="mb-2" data-aos="fade-left" data-aos-delay="400">Scientific storage management through trained workforce.</li>
                            <li className="mb-2" data-aos="fade-left" data-aos-delay="500">Preserves the stocks in scientific manner with low storage losses.</li>
                            <li className="mb-2" data-aos="fade-left" data-aos-delay="600">Registered with Warehousing Development and Regulatory Authority (WDRA).</li>
                            <li className="mb-2" data-aos="fade-left" data-aos-delay="700">Provides e‑Warehouse receipt of stored commodities for securing credit up to 70–80% of the value of stocks from banks at a reasonable rate of interest.</li>
                            <li className="mb-2" data-aos="fade-left" data-aos-delay="800">Storage charges include insurance cover against Fire, Riot, Strike & Malicious Damages, Storm, Tempest, Flood and Inundation.</li>
                            <li className="mb-2" data-aos="fade-left" data-aos-delay="900">Approved handling and transport contractors for undertaking godown transaction services.</li>
                            <li className="mb-2" data-aos="fade-left" data-aos-delay="1000">Periodical quality check‑up and inspection of food grains such as grade quality, etc., undertaken through trained workforce.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ReasonForUtilisation